import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "redCheckoutSuccessStorePayout" };
const _hoisted_2 = { class: "container-fluid bg-brand_deep_blue_light fc-white" };
const _hoisted_3 = { class: "container pb-5" };
const _hoisted_4 = { class: "row" };
const _hoisted_5 = { class: "col-lg-8 offset-lg-2 mt-5 text-center" };
const _hoisted_6 = { class: "container redCheckoutSuccess-container2 mt-n5 pb-4" };
const _hoisted_7 = { class: "row" };
const _hoisted_8 = { class: "col-lg-8 offset-lg-2 mb-3 d-flex" };
const _hoisted_9 = { class: "col-12 bg-white border rounded py-3" };
const _hoisted_10 = { class: "row no-gutters" };
const _hoisted_11 = { class: "col-12 p-3 border" };
const _hoisted_12 = { class: "h5-responsive mb-0" };
const _hoisted_13 = { class: "row" };
const _hoisted_14 = { class: "col-12 text-center py-3" };
const _hoisted_15 = { class: "col-lg-8 offset-lg-2 mb-3 d-flex" };
const _hoisted_16 = { class: "col-12 bg-white border rounded py-3" };
const _hoisted_17 = { class: "row" };
const _hoisted_18 = { class: "col-12 text-center" };
const _hoisted_19 = { class: "d-inline-block p-2" };
const _hoisted_20 = { class: "row" };
const _hoisted_21 = { class: "col-12 text-center pt-45 pb-3" };
const _hoisted_22 = ["href"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_checkout_success_thanks = _resolveComponent("checkout-success-thanks");
    const _component_opening_times_block = _resolveComponent("opening-times-block");
    const _component_google_maps_navigation_button = _resolveComponent("google-maps-navigation-button");
    const _component_vue3_barcode = _resolveComponent("vue3-barcode");
    return (_openBlock(), _createElementBlock("main", _hoisted_1, [
        _createElementVNode("section", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_checkout_success_thanks, {
                            "customer-email": _ctx.customerEmail,
                            "customer-first-name": _ctx.customerFirstName,
                            "transaction-id": _ctx.order.id
                        }, null, 8, ["customer-email", "customer-first-name", "transaction-id"]),
                        _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "h2-responsive mb-3 mb-md-5 mt-2" }, "So geht es jetzt weiter:", -1))
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
                _createElementVNode("article", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                        _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"row border-bottom\"><div class=\"col-12 pr-0\"><h3 class=\"h4-responsive mb-3\"> 1. Besuche deinen <span class=\"d-inline-block\">mySWOOOP-Store</span></h3></div></div><div class=\"row\"><div class=\"col-12 pt-3 pb-3\"><p class=\"font6-responsive\">Bring dein Gerät im ausgewählten Store vorbei.</p><p><img src=\"/images/_new_brand/icons/icon_check.svg\" alt=\"Check\" style=\"margin:0 5px 3px 0;\"><strong>Preisangebot gültig für 3 Tage</strong><img src=\"/images/_new_brand/icons/info_icon.svg\" height=\"16\" width=\"16\" alt=\"Info\" style=\"margin:0 0 3px 10px;\" data-toggle=\"tooltip\" data-placement=\"bottom\" data-original-title=\"Bitte gebe die Ware innerhalb von 3 Tagen im gewählten Store ab.\"></p></div></div>", 2)),
                        _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("address", _hoisted_11, [
                                _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.location.name), 1),
                                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "w-100 font8-responsive fc-gray mb-3" }, [
                                    _createElementVNode("img", {
                                        src: "/images/store_pages/icon/icon_ankaufpartner.svg",
                                        alt: "Ankaufpartner",
                                        style: { "height": "16px", "width": "16px" }
                                    }),
                                    _createTextVNode(" Offizieller "),
                                    _createElementVNode("span", { class: "d-inline-block" }, "mySWOOOP"),
                                    _createTextVNode(" -Ankaufpartner ")
                                ], -1)),
                                _createElementVNode("p", null, [
                                    _createTextVNode(_toDisplayString(_ctx.location.street_name) + " " + _toDisplayString(_ctx.location.street_number) + " ", 1),
                                    _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.location.zip_code) + " " + _toDisplayString(_ctx.location.city), 1)
                                ]),
                                _createElementVNode("p", null, [
                                    _createVNode(_component_opening_times_block, {
                                        opening_times: _ctx.location.opening_times
                                    }, null, 8, ["opening_times"])
                                ]),
                                _createElementVNode("p", null, [
                                    _cache[2] || (_cache[2] = _createElementVNode("strong", null, "Telefonnummer:", -1)),
                                    _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.location.phone_contact), 1)
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                                _createVNode(_component_google_maps_navigation_button, {
                                    class: "buttonBase buttonBlue",
                                    location: _ctx.location
                                }, null, 8, ["location"])
                            ])
                        ])
                    ])
                ]),
                _createElementVNode("article", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                        _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"row border-bottom\"><div class=\"col-12 pr-0\"><h3 class=\"h4-responsive mb-3\">2. Zeige den Barcode vor</h3></div></div><div class=\"row\"><div class=\"col-12 pt-3\"><p> Zeige im <span class=\"d-inline-block\">mySWOOOP</span> -Store den unten stehenden Barcode vor, um deinen Verkauf zu verifizieren. </p><p>Den Barcode findest du auch in deiner Bestätigungsmail.</p></div></div>", 2)),
                        _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("div", _hoisted_19, [
                                    _createVNode(_component_vue3_barcode, {
                                        id: "purchaseCode",
                                        value: _ctx.order.purchaseCode,
                                        format: "CODE128",
                                        heigh: "150"
                                    }, {
                                        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                                _createTextVNode(" Barcode defekt ", -1)
                                            ]))]),
                                        _: 1
                                    }, 8, ["value"])
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("a", {
                                    href: _ctx.downloadUrl,
                                    download: "Vor-Ort-Auszahlung-Barcode.pdf",
                                    type: "application/pdf",
                                    class: "buttonBase buttonGreen"
                                }, " Barcode speichern ", 8, _hoisted_22)
                            ])
                        ])
                    ])
                ]),
                _cache[8] || (_cache[8] = _createStaticVNode("<article class=\"col-lg-8 offset-lg-2 mb-3 d-flex\"><div class=\"col-12 bg-white border rounded py-3\"><div class=\"row border-bottom\"><div class=\"col-12 pr-0\"><h3 class=\"h4-responsive mb-3\">3. Erhalte Dein Geld</h3></div></div><div class=\"row\"><div class=\"col-12 mt-4 pb-4\"><div class=\"\"><p> Dir wird der Ankaufspreis direkt vor Ort im <span class=\"d-inline-block\">mySWOOOP</span> -Store ausgezahlt. </p><p><img src=\"/images/_new_brand/icons/icon_check.svg\" alt=\"Check\" style=\"margin:0 5px 3px 0;\"><strong>Preisangebot gültig für 3 Tage</strong><img src=\"/images/_new_brand/icons/info_icon.svg\" height=\"16\" width=\"16\" alt=\"Info\" style=\"margin:0 0 3px 10px;\" data-toggle=\"tooltip\" data-placement=\"bottom\" data-original-title=\"Bitte gebe die Ware innerhalb von 3 Tagen im gewählten Store ab.\"></p></div></div></div></div></article>", 1))
            ])
        ])
    ]));
}
